query RevenueShareReportsList(
  $page: Int
  $rowsPerPage: Int
  $filter: RevenueShareReportsFilterInput
) {
  revenueShareReports(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      period
      status
      salesAmount {
        value
        currency
      }
      feeAmount {
        value
        currency
      }
      refundsAmount {
        value
        currency
      }
      refundsCount
      disputesAmount {
        value
        currency
      }
      disputesCount
      corrections {
        amount {
          value
          currency
        }
        description
        createdAt
      }
      reportAmount {
        value
        currency
      }
      createdAt
    }
  }
}
